import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import WarningIcon from "@mui/icons-material/Warning";
import CustomSubCardData from "./CustomSubCardData";

import GridContainer from "components/CustomGrid/GridContainer.js";
import GridItem from "components/CustomGrid/GridItem.js";
import { getServerRootUrl } from "../../services/ConfigServices";

import aqi1 from "assets/img/aqi1.png";
import aqi2 from "assets/img/aqi2.png";
import aqi3 from "assets/img/aqi3.png";
import aqi4 from "assets/img/aqi4.png";
import aqi5 from "assets/img/aqi5.png";
import aqi6 from "assets/img/aqi6.png";

const Card = styled.div`
  border: 0 rgba(255, 0, 0, 0.1);
  margin-bottom: 0;
  margin-top: 0.5rem;
  color: #ffffff;
  background: #605F70;
  width: 100%;
  box-shadow: 0 1px 4px 0 grey;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: "break-word";
  font-size: 14px;
  border-radius: 6px;
  font-family: "Source Sans Pro",sans-serif;
`;

const Container = styled.div`
  border: 0;
  display: flex;

  flex-direction: column;
  margin-bottom: 0;
  margin-top: 0px;
  color: #ffffff;
  background: #605F70;
  width: 100%;
  position: relative;
  min-width: 0;
  word-wrap: break-word;
  font-size: 14px;
  font-family: "Source Sans Pro",sans-serif;
`;
const CardTitle = styled.h3`

  margin-top: 0.7rem;
  font-size: 1.1rem;
  font-weight: 500;
  font-family: "Source Sans Pro",sans-serif;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0rem 0.9rem 0rem 0.9rem;
  font-family: "Source Sans Pro",sans-serif;
`;

const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;


const Weatherdiv = styled.div`
    display: flex;
    height: 80px;
    padding-top: 0px;
    text-align: center;
    padding-left: 30px;
`;
const WeatherTemp = styled.div`
    padding-top: 23px;
    font-size: 17px;
  font-weight: 600;
    text-align: center;
    padding-left: 15px;
`;
const WeatherRessTemp = styled.div`
    padding-top: 23px;
    font-size: 14px;
  font-weight: 400;
    text-align: center;
    padding-left: 10px;
`;
const AqiText = styled.div`
    padding-top: 12px;
    font-size: 17px;
  font-weight: 600;
    text-align: center;
    padding-left: 5px;
`;
const AqiTitle = styled.div`
    padding-top: 12px;
    font-size: 14px;
  font-weight: 400;
    text-align: center;
    padding-left: 10px;
`;

const infoWindowImg = {
  height: '64px',
  maxWidth: '98%',
  marginLeft: '1%',
  verticalAlign: 'middle',
  marginBottom: '10px'
}
const aqiImg = {
  height: '45px',
  maxWidth: '98%',
  marginLeft: '4%',
  verticalAlign: 'middle',
  marginBottom: '10px'
}

const iconStyle = { color: "#297373", fontSize: 50, marginTop: "-0.2rem" };

const getAqiImg = (index) => {
  let img = "";
  if (index == 1)
    img = aqi1;
  else if (index == 2)
    img = aqi2;
  else if (index == 3)
    img = aqi3;
  else if (index == 4)
    img = aqi4;
  else if (index == 5)
    img = aqi5;
  else if (index == 6)
    img = aqi6;
  return img;
};
const getAqiTxt = (index) => {
  let txt = "";
  if (index == 1)
    txt = "Bon";
  else if (index == 2)
    txt = "Moyen";
  else if (index == 3)
    txt = "Dégradé";
  else if (index == 4)
    txt = "Mauvais";
  else if (index == 5)
    txt = "Très mauvais";
  else if (index == 6)
    txt = "Extrêmement mauvais";
  return txt;
};

function CustomCardMBM(props) {

  return (
    <div>
      {(props.weatherData  && props.weatherData.locationname && props.weatherData.temperature)?
        (
          <Card>
            <TitleContainer>
              <CardTitle>{props.weatherData.locationname}</CardTitle>
            </TitleContainer>
            <Container>
              <DataList>
                <Weatherdiv>
                  {props.weatherData.icon ? (
                    <img
                      data-src={getServerRootUrl() + "/" + props.weatherData.icon}
                      style={infoWindowImg}
                      src={getServerRootUrl() + "/" + props.weatherData.icon}
                      data-holder-rendered="true"
                      alt={""}
                    />
                  ) : <></>

                  }
                  <WeatherTemp>
                    {props.weatherData.temperature + '°c'}
                  </WeatherTemp>
                  <WeatherRessTemp>
                    {'(Ressenti ' + props.weatherData.temperature_feel + '°c)'}
                  </WeatherRessTemp>
                </Weatherdiv>
                <Weatherdiv>
                  {props.weatherData.aqi ? (
                    <>
                      <img
                        style={aqiImg}
                        src={getAqiImg(props.weatherData.aqi['us-epa-index'])}
                        data-holder-rendered="true"
                        alt={""}
                      />

                      <AqiTitle>
                        {"Index de qualité de l'air : "}
                      </AqiTitle>
                      <AqiText>
                        {getAqiTxt(props.weatherData.aqi['us-epa-index'])}
                      </AqiText>
                    </>) : <></>
                  }
                </Weatherdiv>
              </DataList>
            </Container>
          </Card>
        ) : (<></>)}
    </div>
  );
}

CustomCardMBM.propTypes = {
  siteinfo: PropTypes.object,
};

export default CustomCardMBM;
